import React from 'react';
import DictionariesMetricsRow from './DictionariesMetricsRow';

const DictionariesMetricsRows = ({ dictionariesRequestMetrics }) => (
  dictionariesRequestMetrics.map((dictionaryMetrics) => (
    <DictionariesMetricsRow
      key={dictionaryMetrics?.code}
      name={dictionaryMetrics?.name}
      total={dictionaryMetrics?.requests?.total || 0}
      totalApproved={
            (dictionaryMetrics?.requests?.total_approved || 0)
            + (dictionaryMetrics?.requests?.total_approved_waiting || 0)
          }
      totalDenied={
          (dictionaryMetrics?.requests?.total_denied || 0)
          + (dictionaryMetrics?.requests?.total_denied_waiting || 0)
        }
      totalTransfers={dictionaryMetrics?.requests?.total_transfers || 0}
    />
  ))
);

export default DictionariesMetricsRows;
